import { render, staticRenderFns } from "./msgIndex.vue?vue&type=template&id=82f62b5a&scoped=true&"
import script from "./msgIndex.vue?vue&type=script&lang=js&"
export * from "./msgIndex.vue?vue&type=script&lang=js&"
import style0 from "./msgIndex.vue?vue&type=style&index=0&id=82f62b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f62b5a",
  null
  
)

export default component.exports